import React, { useState } from 'react'
import { Link } from 'react-router-dom'
import SEO from '../components/SEO'

export default function AboutPage() {
  const [expandedCards, setExpandedCards] = useState({
    vaerdier: false,
    mission: false,
    vision: false,
  })
  const [expandedIntro, setExpandedIntro] = useState(false)
  const [expandedTestimonials, setExpandedTestimonials] = useState({
    hessel: false,
    strojer: false,
  })

  const toggleCard = (key) => {
    setExpandedCards((prev) => ({ ...prev, [key]: !prev[key] }))
  }

  const toggleTestimonial = (key) => {
    setExpandedTestimonials((prev) => ({ ...prev, [key]: !prev[key] }))
  }
  return (
    <>
      <SEO
        title="Om os – Kryger Wet Blaster"
        description="Om Krüger Wet Blaster ApS. Dansk designede og producerede vandpoleringsmaskiner i rustfrit stål. Læs om vores mission, vision og værdier."
      />

      {/* Header Banner */}
      <section className="bg-slate-900 text-white border-b border-slate-800 py-12 lg:py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="max-w-3xl">
            <h1 className="text-3xl sm:text-4xl lg:text-5xl font-extrabold tracking-tight mb-4">
              Om os
            </h1>
            <p className="text-slate-300 text-base sm:text-lg leading-relaxed">
              Designet, produceret og samlet i Danmark – produceret på værkstedet med fokus på høj kvalitet, lang levetid og kemi-fri metalrestaurering.
            </p>
          </div>
        </div>
      </section>

      {/* Main Intro Section */}
      <section className="py-14 sm:py-20 bg-white border-b border-slate-200">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-center">
            <div className="lg:col-span-7 space-y-5 text-slate-700 leading-relaxed text-sm sm:text-base">
              <h2 className="text-2xl sm:text-3xl font-extrabold text-slate-900 tracking-tight">
                Om Krüger Wet Blaster
              </h2>
              <div className="w-14 h-1 bg-sky-500 rounded" />

              <p>
                Hos Krüger Wet Blaster er vi specialiseret i at tilbyde effektive og præcise løsninger til metalrestaurering og vedligehold. Vores kabiner er designet, produceret og samlet i Danmark – produceret på værkstedet, og vi er stolte af at levere produkter, der kombinerer høj kvalitet, lang levetid og pålidelighed.
              </p>

              {expandedIntro && (
                <div className="space-y-4 animate-in fade-in duration-200">
                  <p>
                    Vi forstår, hvor vigtigt det er at få det bedste ud af hver metalbehandlingsopgave, og vi stræber efter at gøre vores maskiner til den ideelle løsning for både små og store virksomheder.
                  </p>
                  <p>
                    Vores maskiner er udviklet med fokus på effektivitet, sikkerhed og miljøvenlighed. Vi tilbyder skræddersyede løsninger, der kan tilpasses dine specifikke behov og sikre, at du får optimale resultater – hver gang. Vores maskiner anvendes til en bred vifte af opgaver, fra restaurering og vedligeholdelse af nedbrudte metaldele til fjernelse af lakrester, rust og andre belægninger. Uanset om du arbejder med rustfrit stål, aluminium, titanium, messing, kobber, plast eller gummi, har vi den rette løsning til dig.
                  </p>
                  <p>
                    Vi er ikke kun leverandører af maskiner – vi er din partner gennem hele processen. Vores erfaring er altid klar til at rådgive og hjælpe dig med at finde den bedste løsning til dine behov. Vi går langt for at sikre, at du får et produkt, der lever op til dine forventninger, og vi er altid klar til at støtte dig med teknisk assistance og vejledning.
                  </p>
                  <p>
                    Hos Krüger Wet Blaster er vores mission at levere den bedste teknologi til metalbehandling, som både beskytter dine emner og miljøet. Vi er stolte af at kunne bidrage til din virksomhed med pålidelige og effektive løsninger, der skaber værdi og langvarig kvalitet. Vi ser frem til at hjælpe dig med at optimere din metalbehandling og nå de bedste resultater med Krüger Wet Blaster.
                  </p>
                </div>
              )}

              <div className="pt-1 flex flex-wrap items-center gap-4">
                <button
                  type="button"
                  onClick={() => setExpandedIntro(!expandedIntro)}
                  className="inline-flex items-center gap-2 text-sky-600 hover:text-sky-700 font-semibold text-sm transition-colors cursor-pointer py-1"
                >
                  <span>{expandedIntro ? 'Vis mindre' : 'Læs mere om os'}</span>
                  <i
                    className={`fa-solid fa-chevron-down text-xs transition-transform duration-200 ${
                      expandedIntro ? 'rotate-180' : ''
                    }`}
                    aria-hidden="true"
                  />
                </button>
                <Link
                  to="/kontakt"
                  className="inline-flex items-center gap-2 bg-sky-600 hover:bg-sky-500 text-white font-semibold text-sm px-6 py-2.5 rounded-lg shadow-sm transition-colors"
                >
                  <i className="fa-solid fa-envelope" aria-hidden="true" />
                  <span>Kontakt os i dag</span>
                </Link>
              </div>
            </div>

            <div className="lg:col-span-5 space-y-4">
              <div className="rounded-2xl overflow-hidden border border-slate-200 shadow-xl">
                <img
                  src="https://assets.auxodev.dk/assets/21ecc947-a8ab-45f2-a8fa-709ae6f8815d/print-9424-scaled.jpg"
                  alt="Krüger Wet Blaster produktion og maskiner"
                  className="w-full h-auto object-cover"
                />
              </div>
              <div className="grid grid-cols-2 gap-4">
                <div className="rounded-xl overflow-hidden border border-slate-200 shadow-sm">
                  <img
                    src="https://assets.auxodev.dk/assets/21ecc947-a8ab-45f2-a8fa-709ae6f8815d/2500px-9458.jpg"
                    alt="Vandpolering detalje"
                    className="w-full h-auto object-cover"
                  />
                </div>
                <div className="rounded-xl overflow-hidden border border-slate-200 shadow-sm">
                  <img
                    src="https://assets.auxodev.dk/assets/21ecc947-a8ab-45f2-a8fa-709ae6f8815d/2500px-9462.jpg"
                    alt="Maskine interiør"
                    className="w-full h-auto object-cover"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Mission, Vision & Values Section */}
      <section className="py-16 sm:py-20 bg-slate-50 border-b border-slate-200">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center max-w-2xl mx-auto mb-14">
            <h2 className="text-2xl sm:text-3xl font-extrabold text-slate-900 tracking-tight">
              Mission, vision & værdier
            </h2>
            <div className="w-12 h-1 bg-sky-500 mx-auto rounded mt-3" />
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-12">
            {/* Værdier */}
            <div className="bg-white p-7 sm:p-8 rounded-xl border border-slate-200 shadow-sm flex flex-col justify-between transition-all duration-200 hover:shadow-md">
              <div className="space-y-4">
                <h3 className="text-xl font-bold text-slate-900">Vores værdier</h3>
                <div className="space-y-3 text-sm sm:text-base text-slate-700 leading-relaxed">
                  <p>
                    Hos Krüger Wet Blaster bygger vi vores virksomhed på værdier som kvalitet, pålidelighed, bæredygtighed og en GRØN profil. Vi stræber efter at levere produkter, der ikke kun er effektive, men også skånsomme for både mennesker og miljø.
                  </p>
                  {expandedCards.vaerdier && (
                    <p className="animate-in fade-in duration-200 text-slate-600 pt-2 border-t border-slate-100">
                      Vores fokus er på innovation og teknologiske såvel som simple løsninger, der møder vores kunders behov, samtidig med at vi opretholder højeste standarder for sikkerhed og præcision.
                    </p>
                  )}
                </div>
              </div>
              <div className="pt-5 mt-2">
                <button
                  type="button"
                  onClick={() => toggleCard('vaerdier')}
                  className="inline-flex items-center gap-2 text-xs font-bold uppercase tracking-wider text-sky-600 hover:text-sky-700 transition-colors focus:outline-none"
                >
                  <span>{expandedCards.vaerdier ? 'Vis mindre' : 'Læs mere'}</span>
                  <i className={`fa-solid fa-chevron-${expandedCards.vaerdier ? 'up' : 'down'} text-[10px]`} aria-hidden="true" />
                </button>
              </div>
            </div>

            {/* Mission */}
            <div className="bg-white p-7 sm:p-8 rounded-xl border border-slate-200 shadow-sm flex flex-col justify-between transition-all duration-200 hover:shadow-md">
              <div className="space-y-4">
                <h3 className="text-xl font-bold text-slate-900">Vores mission</h3>
                <div className="space-y-3 text-sm sm:text-base text-slate-700 leading-relaxed">
                  <p>
                    Vores mission er at levere de bedste løsninger til metalrestaurering og vedligeholdelse ved at tilbyde præcise, effektive og miljøvenlige maskiner.
                  </p>
                  {expandedCards.mission && (
                    <p className="animate-in fade-in duration-200 text-slate-600 pt-2 border-t border-slate-100">
                      Vi ønsker at hjælpe vores kunder med at optimere deres metalbehandling / afrensning og sikre langvarige resultater med minimal vedligeholdelse. Hos Krüger Wet Blaster er vi engagerede i at gøre metalbehandling nemmere og mere effektivt for virksomheder af alle størrelser.
                    </p>
                  )}
                </div>
              </div>
              <div className="pt-5 mt-2">
                <button
                  type="button"
                  onClick={() => toggleCard('mission')}
                  className="inline-flex items-center gap-2 text-xs font-bold uppercase tracking-wider text-sky-600 hover:text-sky-700 transition-colors focus:outline-none"
                >
                  <span>{expandedCards.mission ? 'Vis mindre' : 'Læs mere'}</span>
                  <i className={`fa-solid fa-chevron-${expandedCards.mission ? 'up' : 'down'} text-[10px]`} aria-hidden="true" />
                </button>
              </div>
            </div>

            {/* Vision */}
            <div className="bg-white p-7 sm:p-8 rounded-xl border border-slate-200 shadow-sm flex flex-col justify-between transition-all duration-200 hover:shadow-md">
              <div className="space-y-4">
                <h3 className="text-xl font-bold text-slate-900">Vores vision</h3>
                <div className="space-y-3 text-sm sm:text-base text-slate-700 leading-relaxed">
                  <p>
                    Vores vision er at blive den foretrukne leverandør af avancerede og bæredygtige løsninger til metalbehandling.
                  </p>
                  {expandedCards.vision && (
                    <p className="animate-in fade-in duration-200 text-slate-600 pt-2 border-t border-slate-100">
                      Vi stræber efter at sætte standarden for kvalitet og innovation i industrien, så vores kunder kan opnå de bedste resultater samtidig med, at de tager ansvar for miljøet. Vi ser en fremtid, hvor Krüger Wet Blaster er synonymt med pålidelighed, præcision og effektivitet i metalrestaurering.
                    </p>
                  )}
                </div>
              </div>
              <div className="pt-5 mt-2">
                <button
                  type="button"
                  onClick={() => toggleCard('vision')}
                  className="inline-flex items-center gap-2 text-xs font-bold uppercase tracking-wider text-sky-600 hover:text-sky-700 transition-colors focus:outline-none"
                >
                  <span>{expandedCards.vision ? 'Vis mindre' : 'Læs mere'}</span>
                  <i className={`fa-solid fa-chevron-${expandedCards.vision ? 'up' : 'down'} text-[10px]`} aria-hidden="true" />
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* 3 Detail Blocks with Scrape Content */}
      <section className="py-16 sm:py-20 bg-white border-b border-slate-200">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 space-y-16">
          {/* Block 1 */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-10 items-center">
            <div className="space-y-4">
              <h3 className="text-2xl font-bold text-slate-900">
                Effektiv metalrestaurering med Krüger Wet Blaster
              </h3>
              <p className="text-sm text-slate-600 leading-relaxed">
                Krüger Wet Blaster tilbyder avancerede maskiner til effektiv metalrestaurering, der sikrer præcise og langvarige resultater. Vores maskiner er designet til at håndtere de mest krævende opgaver og levere kvalitet uden at gå på kompromis med sikkerheden. Uanset hvad du arbejder med af metaller, har vi den rette løsning til dine behov.
              </p>
              <p className="text-sm text-slate-600 leading-relaxed">
                Med Krüger Wet Blaster kan du opnå en grundig og skånsom behandling af metaldele, som sikrer, at de fremstår som nye. Vores teknologi er både effektiv og miljøvenlig, da den opererer uden skadelige kemikalier. Dette giver både dig og miljøet beskyttelse samtidig med, at du får det bedste ud af dine metalbehandlingsopgaver.
              </p>
            </div>
            <div className="rounded-none overflow-hidden border border-slate-200 shadow-md aspect-[16/10]">
              <img
                src="https://assets.auxodev.dk/assets/21ecc947-a8ab-45f2-a8fa-709ae6f8815d/print-9424-scaled.jpg"
                alt="Effektiv metalrestaurering"
                className="w-full h-full object-cover"
              />
            </div>
          </div>

          {/* Block 2 */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-10 items-center md:flex-row-reverse">
            <div className="rounded-none overflow-hidden border border-slate-200 shadow-md aspect-[16/10] order-last md:order-first">
              <img
                src="https://assets.auxodev.dk/assets/21ecc947-a8ab-45f2-a8fa-709ae6f8815d/2500px-9458.jpg"
                alt="Pålidelige vandpoleringsmaskiner"
                className="w-full h-full object-cover"
              />
            </div>
            <div className="space-y-4">
              <h3 className="text-2xl font-bold text-slate-900">
                Brugervenlige og pålidelige vandpoleringsmaskiner
              </h3>
              <p className="text-sm text-slate-600 leading-relaxed">
                Vores maskiner er designet med fokus på brugervenlighed og pålidelighed. Krüger Wet Blaster er nem at betjene, hvilket gør den ideel til både små og store virksomheder. Den robuste konstruktion i rustfri stål sikrer, at maskinen kan håndtere selv de mest krævende opgaver uden problemer.
              </p>
              <p className="text-sm text-slate-600 leading-relaxed">
                Maskinerne er udstyret med funktioner, der forenkler arbejdsgangen og sikrer, at hver behandling lever op til de højeste standarder. Den lange levetid og lave vedligeholdelse gør Krüger Wet Blaster til en økonomisk løsning, der leverer pålidelige resultater år efter år.
              </p>
            </div>
          </div>

          {/* Block 3 */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-10 items-center">
            <div className="space-y-4">
              <h3 className="text-2xl font-bold text-slate-900">
                Bæredygtige løsninger til metalbehandling
              </h3>
              <p className="text-sm text-slate-600 leading-relaxed">
                Hos Krüger Wet Blaster er vi engagerede i at beskytte både vores kunder og miljøet. Vores maskiner anvender en kemi-fri proces, der sikrer en miljøvenlig behandling af metaldele. Denne teknologi minimerer den negative påvirkning af vores natur og bidrager til et sundt og sikkert arbejdsmiljø.
              </p>
              <p className="text-sm text-slate-600 leading-relaxed">
                Vores mål er at hjælpe virksomheder med at reducere deres miljøaftryk samtidig med, at de opnår fremragende resultater i metal restaureringsbehandlingen. Med Krüger Wet Blaster kan du både øge effektiviteten og arbejde på en mere bæredygtig måde.
              </p>
            </div>
            <div className="rounded-none overflow-hidden border border-slate-200 shadow-md aspect-[16/10]">
              <img
                src="https://assets.auxodev.dk/assets/21ecc947-a8ab-45f2-a8fa-709ae6f8815d/2500px-9462.jpg"
                alt="Bæredygtige løsninger til metalbehandling"
                className="w-full h-full object-cover"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Testimonials from Scrape */}
      <section className="py-16 bg-slate-50 border-b border-slate-200">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="mb-10 text-center">
            <h2 className="text-2xl sm:text-3xl font-extrabold text-slate-900 tracking-tight">
              Anbefalinger fra erhvervslivet
            </h2>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-start">
            <blockquote className="bg-white rounded-xl p-8 border border-slate-200 shadow-sm space-y-4">
              <div className="flex text-amber-400 gap-1 text-sm">
                {[...Array(5)].map((_, i) => (
                  <i key={i} className="fa-solid fa-star" aria-hidden="true" />
                ))}
              </div>
              <div>
                <p className="text-sm text-slate-700 leading-relaxed italic">
                  &ldquo;Kruger Wet Blaster gør hverdag en stor forskel for os i forbindelse med vores service og reparationsarbejder. Afrensningen udføres hurtigt i en høj kvalitet, og samtidig med lavest mulig miljøbelastning
                  {expandedTestimonials.hessel ? (
                    <span>, både for medarbejdere som betjener maskinen, og mht. til restaffald og udledning. Tillige er ”Wet Blasteren” velbygget og i en høj kvalitet, hvorfor vi også har installeret dem i stort antal i vores værksteder. De bedste anbefalinger lyder herfra.&rdquo;</span>
                  ) : (
                    <span>...&rdquo;</span>
                  )}
                </p>
                <button
                  type="button"
                  onClick={() => toggleTestimonial('hessel')}
                  aria-expanded={expandedTestimonials.hessel}
                  className="mt-3 inline-flex items-center gap-1.5 text-xs font-semibold text-sky-600 hover:text-sky-700 cursor-pointer transition-colors"
                >
                  <span>{expandedTestimonials.hessel ? 'Vis mindre' : 'Læs hele anbefalingen'}</span>
                  <i
                    className={`fa-solid fa-chevron-down text-[10px] transition-transform duration-200 ${
                      expandedTestimonials.hessel ? 'rotate-180' : ''
                    }`}
                    aria-hidden="true"
                  />
                </button>
              </div>
              <footer className="pt-4 border-t border-slate-100">
                <div className="font-bold text-slate-900 text-sm">Lars Hillker Madsen</div>
                <div className="text-xs text-sky-600 font-medium">Facility Manager, EJNER HESSEL</div>
              </footer>
            </blockquote>

            <blockquote className="bg-white rounded-xl p-8 border border-slate-200 shadow-sm space-y-4">
              <div className="flex text-amber-400 gap-1 text-sm">
                {[...Array(5)].map((_, i) => (
                  <i key={i} className="fa-solid fa-star" aria-hidden="true" />
                ))}
              </div>
              <div>
                <p className="text-sm text-slate-700 leading-relaxed italic">
                  &ldquo;Vi har anvendt Krüger Wet Blaster i vores bilsamling i lang tid, og resultaterne har været fantastiske.
                  {expandedTestimonials.strojer ? (
                    <span> Maskinen leverer ikke kun en utrolig præcision, men også et perfekt finish på vores bil dele. Det er virkelig en succesfuld for vores virksomhed.&rdquo;</span>
                  ) : (
                    <span> Maskinen leverer ikke kun en utrolig præcision...&rdquo;</span>
                  )}
                </p>
                <button
                  type="button"
                  onClick={() => toggleTestimonial('strojer')}
                  aria-expanded={expandedTestimonials.strojer}
                  className="mt-3 inline-flex items-center gap-1.5 text-xs font-semibold text-sky-600 hover:text-sky-700 cursor-pointer transition-colors"
                >
                  <span>{expandedTestimonials.strojer ? 'Vis mindre' : 'Læs hele anbefalingen'}</span>
                  <i
                    className={`fa-solid fa-chevron-down text-[10px] transition-transform duration-200 ${
                      expandedTestimonials.strojer ? 'rotate-180' : ''
                    }`}
                    aria-hidden="true"
                  />
                </button>
              </div>
              <footer className="pt-4 border-t border-slate-100">
                <div className="font-bold text-slate-900 text-sm">Jørgen</div>
                <div className="text-xs text-sky-600 font-medium">Strøjer Samlingen</div>
              </footer>
            </blockquote>
          </div>
        </div>
      </section>
    </>
  )
}
